<!-- eslint-disable max-len -->
<template>
  <div>
    <div class="info-user">
      <img
        v-if="img"
        :src="img"
        class="round-bordered-img-small">
      <div
        v-else
        class="img-responsive-home round-bordered-img-home"/>
    </div>
    <div class="label-home-1">Selamat Datang</div>
    <div class="label-home-2">{{ name }}</div>
    <div class="label-home-3">{{ nis }}</div>
    <div class="content-officeless-home">
      <!-- Siswa -->
    </div>

    <div class="copyright-section">
      Copyright © 2021 NextDev
    </div>
  </div>
</template>

<script>
/* eslint-disable max-len, no-unused-vars, no-console */

export default {
  components: {
  },
  data() {
    return {
      name: localStorage.getItem('nama_siswa'),
      img: localStorage.getItem('photo'),
      nis: localStorage.getItem('nis'),
    };
  },
  computed: {
  },
  watch: {
  },
  created() {
  },
  mounted() {
  },
  methods: {
  },
  validations() {
    return {
    };
  },
};
</script>



// WEBPACK FOOTER //
// src/views/home/jHomeSiswa.vue